<div class="page-wrapper">
  <div class="chapeau-background"></div>
  
  <!-- <app-navbar *ngIf="isAuthenticated && showNavbarFooter" (toggleSidebar)="toggleSidebar()"></app-navbar> -->
  
  <div class="main-layout-container">
    <app-sidebar *ngIf="isAuthenticated && showNavbarFooter" 
                 [isOpen]="isSidebarOpen" 
                 (sidebarToggle)="onSidebarToggle($event)">
    </app-sidebar>

    <div class="content" [class.content-shifted]="isSidebarOpen">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- <app-footer *ngIf="isAuthenticated && showNavbarFooter"></app-footer> -->

  <!-- BannerWeb top ad (shown on all pages) -->
  <div *ngIf="isAuthenticated && showNavbarFooter && bannerAd" class="banner-ad-container w-full bg-white border-b border-gray-200 flex justify-center py-5">
    <a *ngIf="bannerAd.href; else bannerNoLink" [href]="bannerAd.href" target="_blank" rel="noopener">
      <img [src]="bannerAd.pathimage" [alt]="bannerAd.titre || 'banner'" style="width: 728px; height: 140px; object-fit: contain;" />
    </a>
    <ng-template #bannerNoLink>
      <img [src]="bannerAd.pathimage" [alt]="bannerAd.titre || 'banner'" style="width: 728px; height: 140px; object-fit: contain;" />
    </ng-template>
  </div>

  <!-- UnderFooterWeb bottom ad (shown on all pages) -->
  <div *ngIf="isAuthenticated && showNavbarFooter && underFooterAd" class="under-footer-ad-container w-full bg-white border-t border-gray-200 flex justify-center py-5">
    <a *ngIf="underFooterAd.href; else footerNoLink" [href]="underFooterAd.href" target="_blank" rel="noopener">
      <img [src]="underFooterAd.pathimage" [alt]="underFooterAd.titre || 'under-footer'" style="width: 1219px; height: 40px; object-fit: contain;" />
    </a>
    <ng-template #footerNoLink>
      <img [src]="underFooterAd.pathimage" [alt]="underFooterAd.titre || 'under-footer'" style="width: 1219px; height: 40px; object-fit: contain;" />
    </ng-template>
  </div>

</div>